import _classCallCheck from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { getCoordsDataType } from './shader_compiler';
export var ScatterProgram = function ScatterProgram(updateSize, sliceDim, indicesRank, updatesRank, strides, shape) {
  var summingDupeIndex = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;

  _classCallCheck(this, ScatterProgram);

  this.variableNames = ['updates', 'indices', 'defaultValue'];
  this.outputShape = shape;
  var stridesType = getCoordsDataType(strides.length);
  var dtype = getCoordsDataType(shape.length);
  var indicesString = '';

  if (indicesRank === 1) {
    indicesString = 'i';
  } else if (indicesRank === 2) {
    indicesString = 'i, j';
  }

  var indicesSnippet = "getIndices(".concat(indicesString, ")");
  var updatesString = '';

  if (updatesRank === 1) {
    updatesString = 'i';
  } else if (updatesRank === 2) {
    updatesString = 'i, coords[1]';
  }

  var updatesSnippet = "getUpdates(".concat(updatesString, ")");
  var strideString = sliceDim > 1 ? 'strides[j]' : 'strides';
  this.userCode = "\n        ".concat(stridesType, " strides = ").concat(stridesType, "(").concat(strides, ");\n\n        void main() {\n          ").concat(dtype, " coords = getOutputCoords();\n          float sum = 0.0;\n          bool found = false;\n          for (int i = 0; i < ").concat(updateSize, "; i++) {\n            int flattenedIndex = 0;\n            for (int j = 0; j < ").concat(sliceDim, "; j++) {\n              int index = round(").concat(indicesSnippet, ");\n              flattenedIndex += index * ").concat(strideString, ";\n            }\n            if (flattenedIndex == coords[0]) {\n              sum += ").concat(updatesSnippet, ";\n              found = true;\n            }\n          }\n          setOutput(mix(getDefaultValue(), sum, float(found)));\n        }\n      ");
};